module.exports = __webpack_public_path__ + "img/pick4_yellow.21365dca.png";